import React from 'react';
import { useLocale } from '../../contexts/LocaleContext';
import { useAuth } from '../../contexts/AuthContext';
import { LOCALE_CONFIG } from '../../utils/localeConfig';

/**
 * CountrySelector Component
 * Allows users to manually select their country/region
 * This overrides auto-detection and updates currency, pricing, language, and date format
 */
const CountrySelector = ({ className = '' }) => {
  const { country, setCountry } = useLocale();
  const { updateUserProfile } = useAuth();

  // Get all available countries (excluding DEFAULT for now, we can show it as "Worldwide")
  const countries = Object.entries(LOCALE_CONFIG).map(([code, config]) => ({
    code,
    name: config.name,
    flag: config.flag,
    currency: config.currency.code
  }));

  const handleCountryChange = (e) => {
    const newCountry = e.target.value;
    // Pass updateUserProfile function to save to Firebase
    setCountry(newCountry, updateUserProfile);
  };

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      <label htmlFor="country-selector" className="text-sm font-medium text-gray-700 whitespace-nowrap">
        Country:
      </label>

      <select
        id="country-selector"
        value={country || 'DEFAULT'}
        onChange={handleCountryChange}
        className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-green-500 focus:border-green-500 text-sm bg-white"
      >
        {countries.map(({ code, name, flag, currency }) => (
          <option key={code} value={code}>
            {flag} {name} ({currency})
          </option>
        ))}
      </select>
    </div>
  );
};

export default CountrySelector;
